module.exports = __webpack_public_path__ + "static/media/background-login-levo.98cdbbfd.png";